import { render } from "./ModalLayout.vue?vue&type=template&id=221d7099"
import script from "./ModalLayout.vue?vue&type=script&lang=js"
export * from "./ModalLayout.vue?vue&type=script&lang=js"

import "./ModalLayout.vue?vue&type=style&index=0&id=221d7099&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__